import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { applicationSettingsGuard } from '@app/core/guard/application-settings-guard'
import { ScopeOverviewComponent } from '@app/features/scope-overview/components/scope-overview/scope-overview.component'
import { CanDeactivateGuard } from '@core/guard/can-deactivate-guard'
import { ChangeRequestContainerComponent } from './change-request/components/change-request-container.component'
import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { ScopeGuard } from './guard/scope-overview.guard'
import { ScopeOverviewScopeComponent } from './components/scope-overview/scope-overview-scope/scope-overview-scope.component'

const routes: Routes = [
  {
    path: '',
    component: ScopeOverviewComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [ScopeGuard],
    children: [
      {
        path: '',
        component: ScopeOverviewScopeComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'change-request/:changeRequestId',
        component: ChangeRequestContainerComponent,
        data: {
          settings: [ApplicationSetting.CHANGE_REQUEST, ApplicationSetting.SCOPE__ENABLE_CHANGE_REQUEST],
        },
        canActivate: [applicationSettingsGuard],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
]

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class ScopeOverviewRoutingModule {}
